module.exports = __webpack_public_path__ + "assets/img/icon-ruler-gray.dd52b81a.png";